export default {
  order_again: 'Ordina di nuovo',
  error_messages: {
    product_does_not_exist: 'Il prodotto non è più disponibile',
  },
  success_messages: {
    product_added_to_card: 'Prodotto aggiunto al carrello',
  },
};
